// @flow
import React from 'react';
import { compose } from 'redux';
import dataComponent from '../hoc/dataComponent';
import { defineMessages, FormattedMessage } from 'react-intl';

import * as meActions from '../actions/me';

import Subscription from '../components/settings/Subscription';

import styles from './Settings.css';

import protectedComponent from '../hoc/protectedComponent';
import Section from '../components/settings/Section';
import Account from '../components/settings/Account';
import App from '../components/settings/App';
import * as clientActions from '../actions/client';
import { META_TITLE_PREFIX } from '../constants';

declare var __ELECTRON__: boolean;

const messages = defineMessages({
  metaTitle: {
    id: 'settings.meta.title',
    defaultMessage: 'Settings',
  },
});

const Settings = () => {
  return (
    <div className={styles.acc}>
      <h1 className={styles.header}>
        <FormattedMessage id="settings.header" defaultMessage="Settings" />
      </h1>
      <Section
        id="account"
        title={<FormattedMessage id="settings.account.header" defaultMessage="Account" />}
      >
        <Account />
      </Section>
      <Section
        id="subscription"
        title={<FormattedMessage id="settings.subs.header" defaultMessage="Subscription" />}
      >
        <Subscription />
      </Section>
      <Section id="app" title={<FormattedMessage id="settings.app.header" defaultMessage="App" />}>
        <App />
      </Section>
    </div>
  );
};

Settings.onDataFetch = (store, params, location, intl) => {
  store.dispatch(
    clientActions.setHelmet({
      title: META_TITLE_PREFIX + intl.formatMessage(messages.metaTitle),
    })
  );
};

function fetchData(store) {
  return store.dispatch(meActions.loadMe());
}

export default compose(
  protectedComponent({ authenticatedOnly: true }),
  dataComponent(fetchData)
)(Settings);
